import { MarkdownLinkHelper } from './markdown/MarkdownLinkHelper';

/** Naming rules for the file attachments rendered in a chat message. */
export class ChatAttachmentHelper {
  private static readonly FALLBACK_NAME = 'Attachment';

  /** Display name for a file part. Files produced by a tool mid-answer stream in without a name —
   * the AI SDK's `file` stream chunk carries no `filename` — so fall back to the last segment of the
   * storage key, which is the name the file was stored under. */
  static getDisplayName(fileName: string | undefined, fileRef: string): string {
    if (fileName) return fileName;
    if (fileRef.startsWith('data:') || fileRef.startsWith('blob:'))
      return ChatAttachmentHelper.FALLBACK_NAME;

    const storedName = MarkdownLinkHelper.getFileName(
      fileRef,
      ChatAttachmentHelper.FALLBACK_NAME
    );
    return storedName.includes('.')
      ? storedName
      : ChatAttachmentHelper.FALLBACK_NAME;
  }

  static splitByFolder<T extends { fileName: string }>(
    items: T[]
  ): { files: T[]; folders: { name: string; items: T[] }[] } {
    const files: T[] = [];
    const folders = new Map<string, T[]>();

    items.forEach((item) => {
      const slash = item.fileName.indexOf('/');
      if (slash <= 0) {
        files.push(item);
        return;
      }
      const name = item.fileName.slice(0, slash);
      folders.set(name, [...(folders.get(name) ?? []), item]);
    });

    return {
      files,
      folders: [...folders]
        .map(([name, grouped]) => ({ name, items: grouped }))
        .sort((a, b) => a.name.localeCompare(b.name)),
    };
  }
}
